import Vue from 'vue'
import { Route } from 'vue-router'

export const EMBED_PATH = '/temp-embed/instruments'
const STORAGE_KEY = 'temp-embed-instrument-token'

function storedToken(): string {
  try {
    return sessionStorage.getItem(STORAGE_KEY) || ''
  } catch (_) {
    // Storage can be unavailable in an embedded browser; keep the token in memory.
    return ''
  }
}

export const embedAuth = Vue.observable({ token: storedToken() })

export function captureToken(route: Route): boolean {
  if (!Object.prototype.hasOwnProperty.call(route.query, 'token')) return false
  const value = route.query.token
  embedAuth.token = typeof value === 'string' ? value.trim() : ''
  try {
    if (embedAuth.token) sessionStorage.setItem(STORAGE_KEY, embedAuth.token)
    else sessionStorage.removeItem(STORAGE_KEY)
  } catch (_) {
    // Keep the hash URL credential when storage is blocked, so refresh still works.
    return false
  }
  return true
}
